import React from "react";
import "./HeroTop.css";

function HeroTop() {
  return (
    <section className="dhp-hero-section">
      <div className="dhp-hero-overlay" />

      <div className="dhp-hero-container">
        <div className="dhp-hero-content">
          <span className="dhp-hero-badge">Web Hosting & Domain Platform</span>

          <h1>
            The Web Hosting <br />
            Platform Made for You
          </h1>

          <p>
            Search domains, manage hosting, secure your brand, and launch your
            business online with a premium experience.
          </p>

          <div className="dhp-hero-actions">
            <button type="button" className="dhp-btn dhp-btn-primary">
              Get Started
            </button>
            <button type="button" className="dhp-btn dhp-btn-secondary">
              Read More
            </button>
          </div>
        </div>

        <div className="dhp-hero-visual">
          <div className="dhp-laptop-card">
            <div className="dhp-screen-header">
              <span />
              <span />
              <span />
            </div>

            <div className="dhp-screen-content">
              <h3>DoHostingPay</h3>
              <p>Domain, hosting, email and security dashboard</p>

              <div className="dhp-chart-card">
                <div className="dhp-chart-line" />
                <div className="dhp-chart-line small" />
              </div>
            </div>
          </div>

          <div className="dhp-tablet-card">
            <h4>Hosting</h4>
            <p>Fast setup</p>
          </div>

          <div className="dhp-mobile-card">
            <h4>Secure</h4>
            <p>SSL Ready</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroTop;